<template>
  <v-row justify="center" align="center" class="skewed-bg">
    <v-col cols="12" sm="11" md="10" lg="10" style="z-index:1">
      <v-row style="z-index:1">
        <!-- <v-spacer></v-spacer> -->
        <v-col cols="12" class="py-0">
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="10" md="6" class="py-0" align="right">
              <v-row>
                <v-col cols="12" sm="6" md="6" class="pt-0">
                  <v-menu bottom right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        outlined
                        color="grey darken-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <span class="text_body_4">{{
                          "ราย" + formatType(type)
                        }}</span>
                        <v-icon size="24" right>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="type = 'day'">
                        <v-list-item-title>
                          <span class="text_body_4">รายวัน</span>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'week'">
                        <v-list-item-title>
                          <span class="text_body_4">รายสัปดาห์</span>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'month'">
                        <v-list-item-title>
                          <span class="text_body_4">รายเดือน</span>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'year'">
                        <v-list-item-title>
                          <span class="text_body_4">รายปี</span>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  class="pt-0"
                  v-show="type == 'day'"
                >
                  <v-menu
                    v-model="menu_date"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDatePicker(date)"
                        filled
                        background-color="white"
                        dense
                        single-line
                        label="วันที่"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      locale="th"
                      @input="menu_date = false"
                      :max="today"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  class="pt-0"
                  v-show="type == 'week'"
                >
                  <v-menu
                    ref="menu_week"
                    v-model="menu_week"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatWeekPicker(week)"
                        filled
                        background-color="white"
                        dense
                        single-line
                        label="วันที่"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="week"
                      range
                      locale="th"
                      :max="today"
                      no-title
                    >
                      <!-- <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu_week = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_week.save(week)"
                        >OK</v-btn
                      >-->
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  class="pt-0"
                  v-show="type == 'month'"
                >
                  <v-menu
                    v-model="menu_month"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatMonthPicker(month)"
                        filled
                        background-color="white"
                        dense
                        single-line
                        label="เดือน"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="month"
                      type="month"
                      locale="th"
                      @input="menu_month = false"
                      :max="today"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  class="pt-0"
                  v-show="type == 'year'"
                >
                  <v-menu
                    ref="menu_year"
                    v-model="menu_year"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatYearPicker(year)"
                        filled
                        background-color="white"
                        dense
                        single-line
                        label="ปี"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="year"
                      @input="saveYear(year)"
                      reactive
                      no-title
                      locale="th"
                      :max="today"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-card>
        <v-card-title>
          <h1>ประวัติการค้นหาคำศัพท์</h1>
        </v-card-title>
        <v-container>
          <v-card outlined>
            <v-container>
              <v-row justify="center" align="center">
                <v-spacer v-if="!mobile"></v-spacer>
                <v-col
                  :md="desktop ? '3' : '4'"
                  sm="5"
                  cols="12"
                  class="py-0"
                  :align="mobile ? 'center' : 'right'"
                >
                  <v-menu
                    :close-on-content-click="false"
                    offset-y
                    v-model="menu_mode"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :class="mobile ? 'my-2' : 'my-2'"
                        tile
                        color="#0e62ed"
                        outlined
                        :block="mobile"
                        v-on="on"
                      >
                        <v-icon left>mdi-note-text</v-icon>
                        <h4 class="mt-1">{{ search_mode_text }}</h4>
                        <v-icon right>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>

                    <v-card>
                      <v-list>
                        <v-list-item
                          @click="
                            search_mode_text = item.text;
                            api_url = item.api_url;
                            search_title = item.title;
                            mode = item.name;
                            menu_mode = false;
                          "
                          v-for="item in mode_list"
                          :key="item.title"
                        >
                          <v-list-item-action class="mr-2">
                            <v-icon
                              :color="
                                search_mode_text == item.text ? 'primary' : null
                              "
                              >mdi-note-text</v-icon
                            >
                          </v-list-item-action>
                          <v-list-item-title>
                            <span
                              :class="
                                search_mode_text == item.text
                                  ? 'text_body_6 primary--text'
                                  : 'text_body_6'
                              "
                              >{{ item.text }}</span
                            >
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col
                  :md="desktop ? '2' : '3'"
                  sm="3"
                  cols="12"
                  class="py-0"
                  :align="mobile ? 'center' : 'center'"
                >
                  <v-btn
                    :disabled="history.length == 0"
                    tile
                    color="#0e62ed"
                    :dark="history.length > 0"
                    @click="exportExcel"
                    :block="mobile"
                  >
                    <v-icon left>mdi-note-text</v-icon>
                    <h4 class="mt-1">{{ "ออกรายงาน" }}</h4>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-card-title class="py-0">
              <v-icon size="16" left color="#53a8e2">mdi-circle</v-icon>
              <span class="text_title_6 mt-1">{{
                filter_item + " " + search_title
              }}</span>
            </v-card-title>
            <v-row justify="center" align="center">
              <v-col cols="12" md="11" align="center">
                <div id="chart">
                  <apexchart
                    type="bar"
                    height="350"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
        <v-container>
          <v-card-title class="px-0">
            <h2>{{ search_title + " : " + filter_item }}</h2>
          </v-card-title>
          <v-card outlined v-if="history.length > 0 && !mobile">
            <v-card>
              <v-container>
                <v-row>
                  <v-col cols="3">
                    <div class="text_title_5">
                      <v-avatar tile size="42">
                        <v-img src="@/assets/icon/no.svg"></v-img>
                      </v-avatar>
                      {{ headers[0] }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text_title_5">
                      <v-avatar tile size="42">
                        <v-img src="@/assets/icon/alphabet.svg"></v-img>
                      </v-avatar>
                      {{ headers[1] }}
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div class="text_title_5">
                      <v-avatar tile size="42">
                        <v-img src="@/assets/icon/count.svg"></v-img>
                      </v-avatar>
                      {{ headers[2] }}
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-container class="py-0">
              <v-row>
                <v-col cols="3" class="Line-3">
                  <v-row v-for="(item, index) in history" :key="index">
                    <v-col>
                      <v-list-item-content class="pb-0">
                        <v-list-item-title>
                          <span class="text_body_5">{{ index + 1 }}</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" class="Line-3">
                  <v-row v-for="(item, index) in history" :key="index">
                    <v-col>
                      <v-list-item-content
                        v-if="mode == 'topsearch'"
                        class="pb-0"
                      >
                        <v-list-item-title>
                          <span class="text_body_5">
                            {{ item.alphabet ? item.alphabet : "-" }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-content
                        v-if="mode == 'unknown_word'"
                        class="pb-0"
                      >
                        <v-list-item-title>
                          <span class="text_body_5">
                            {{
                              item.unknownWordName ? item.unknownWordName : "-"
                            }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="3" class="Line-3">
                  <v-row v-for="(item, index) in history" :key="index">
                    <v-col>
                      <v-list-item-content class="pb-0">
                        <v-list-item-title>
                          <span class="text_body_5">
                            {{ item.countPerDay }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>

          <v-row v-if="history.length > 0 && mobile">
            <v-col
              v-for="(item, index) in history"
              :key="index"
              cols="12"
              class="pt-0"
            >
              <v-card>
                <v-container>
                  <v-row justify="center" align="center">
                    <v-col cols="12" class="py-0">
                      <v-row justify="center" align="center">
                        <v-col cols="6" class="py-0">
                          <v-list-item-content class="pb-0">
                            <v-list-item-title>
                              <span class="text_title_5">{{ headers[0] }}</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-list-item-content class="pb-0">
                            <v-list-item-title>
                              <span class="text_body_5">{{ index + 1 }}</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-row justify="center" align="center">
                        <v-col cols="6" class="py-0">
                          <v-list-item-content class="pb-0">
                            <v-list-item-title>
                              <span class="text_title_5">{{ headers[1] }}</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-list-item-content
                            v-if="mode == 'topsearch'"
                            class="pb-0"
                          >
                            <v-list-item-title>
                              <span class="text_body_5">
                                {{ item.alphabet ? item.alphabet : "-" }}
                              </span>
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-content
                            v-if="mode == 'unknown_word'"
                            class="pb-0"
                          >
                            <v-list-item-title>
                              <span class="text_body_5">
                                {{
                                  item.unknownWordName
                                    ? item.unknownWordName
                                    : "-"
                                }}
                              </span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-row justify="center" align="center">
                        <v-col cols="6" class="py-0">
                          <v-list-item-content class="pb-0">
                            <v-list-item-title>
                              <span class="text_title_5">{{ headers[2] }}</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-list-item-content class="pb-0">
                            <v-list-item-title>
                              <span class="text_body_5">
                                {{ item.countPerDay }}
                              </span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col cols="6" class="py-0">
                      <v-row v-for="(header, i) in headers" :key="i">
                        <v-col cols="12" class="py-0">
                          <div class="text_title_5">{{ header }}</div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <div class="text_body_5">{{ index + 1 }}</div>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <div class="text_body_5" v-if="mode == 'topsearch'">
                            {{ item.alphabet ? item.alphabet : "-" }}
                          </div>
                          <div
                            class="text_body_5"
                            v-if="mode == 'unknown_word'"
                          >
                            {{
                              item.unknownWordName ? item.unknownWordName : "-"
                            }}
                          </div>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <div class="text_body_5">
                            {{ item.countPerDay }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>-->
                </v-container>
              </v-card>
            </v-col>
          </v-row>

          <v-card-subtitle
            v-if="history.length == 0"
            class="text_body_5 ml-5"
            >{{ "- ไม่พบประวัติการค้นหา" }}</v-card-subtitle
          >
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      // permission value
      permission_history: false,
      permission_unknow_word: false,
      //
      menu_mode: false,
      type: "day",
      today: new Date().toISOString().substr(0, 10),
      date: new Date().toISOString().substr(0, 10),
      week: [],
      month: new Date().toISOString().substr(0, 7),
      year: new Date().toISOString().substr(0, 10),
      filter_item: 20,
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      menu_date: false,
      menu_week: false,
      menu_month: false,
      menu_year: false,
      series: [],
      search_mode_text: "คำที่ค้นหามากที่สุด",
      search_title: "อันดับการค้นหาคำศัพท์",
      api_url: "searchword/topsearch",
      mode: "topsearch",
      mode_list: [
        {
          name: "topsearch",
          title: "อันดับการค้นหาคำศัพท์",
          text: "คำที่ค้นหามากที่สุด",
          api_url: "searchword/topsearch",
        },
        {
          name: "unknown_word",
          title: "อันดับการค้นหาคำศัพท์ที่ไม่มีในระบบ",
          text: "คำค้นหาที่ไม่มีในระบบ",
          api_url: "unknown_word",
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "70%",
            endingShape: "flat",
          },
        },

        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          title: {
            text: "อันดับ",
          },
          categories: [
            // "Feb",
            // "Mar",
            // "Apr",
            // "May",
            // "Jun",
            // "Jul",
            // "Aug",
            // "Sep",
            // "Oct",
          ],
        },
        yaxis: {
          title: {
            text: "จำนวนครั้ง",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " ครั้ง";
            },
          },
        },
      },

      items: [
        {
          text: "20 คำศัพท์",
          value: 20,
        },
        {
          text: "15 คำศัพท์",
          value: 15,
        },
        {
          text: "10 คำศัพท์",
          value: 10,
        },
        {
          text: "7 คำศัพท์",
          value: 7,
        },
        {
          text: "5 คำศัพท์",
          value: 5,
        },
      ],

      history: [],
      update_value_setTimeOut: null,
    };
  },
  created() {
    const module_name = "permission_backOffice";
    const func_history = "history";
    const func_unknow_word = "unknown_word";
    const redirect = { name: "Dashboard", params: { mode: "all" } };
    if (this.$session.get(module_name)) {
      if (
        this.$session.get(module_name).includes(func_history) ||
        this.$session.get(module_name).includes(func_unknow_word)
      ) {
        this.permission_history = this.$session.get(module_name)
          ? this.$session.get(module_name).includes(func_history)
          : false;
        this.permission_unknow_word = this.$session.get(module_name)
          ? this.$session.get(module_name).includes(func_unknow_word)
          : false;
        this.initalMethod();
      } else {
        this.$router.push(redirect);
      }
    } else {
      this.$router.push(redirect);
    }
  },
  computed: {
    headers() {
      var headers = [];
      headers = [
        "ลำดับ",
        "คำทับศัพท์",
        "จำนวนครั้ง/" + this.formatType(this.type),
      ];
      return headers;
    },
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "$route.params.mode"(value) {
      switch (value) {
        case "history":
          this.search_mode_text = "คำที่ค้นหามากที่สุด";
          this.search_title = "อันดับการค้นหาคำศัพท์";
          this.api_url = "searchword/topsearch";
          this.mode = "topsearch";
          break;
        case "unknown_word":
          this.search_mode_text = "คำค้นหาที่ไม่มีในระบบ";
          this.search_title = "อันดับการค้นหาคำศัพท์ที่ไม่มีในระบบ";
          this.api_url = "unknown_word";
          this.mode = "unknown_word";
          break;
        default:
          this.$router.push({ name: "History", params: { mode: "history" } });
          break;
      }
    },
    menu_year(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    date(val) {
      if (val) {
        this.getHistory();
      }
    },
    filter_item(val) {
      this.getHistory();
    },
    month(val) {
      if (val) {
        this.getHistory();
      }
    },
    year(val) {
      if (val) {
        this.getHistory();
      }
    },
    week(val) {
      if (val.length == 1) {
        this.startOfWeek(new Date(val[0]));
        this.endOfWeek(new Date(val[0]));
      }
      if (val.length == 2) {
        this.getHistory();
      }
    },
    type(val) {
      this.chartOptions = {};
      if (val) {
        if (val == "week") {
          this.startOfWeek(new Date(this.today));
          this.endOfWeek(new Date(this.today));
        }
        this.getHistory();
      }
    },
    search_mode_text(val) {
      if (val) {
        this.getHistory();
      }
    },
  },
  methods: {
    initalMethod() {
      if (this.permission_history && this.permission_unknow_word) {
        //  normal mode
        this.search_mode_text = "คำที่ค้นหามากที่สุด";
        this.search_title = "อันดับการค้นหาคำศัพท์";
        this.api_url = "searchword/topsearch";
        this.mode = "topsearch";
        this.mode_list = [
          {
            name: "topsearch",
            title: "อันดับการค้นหาคำศัพท์",
            text: "คำที่ค้นหามากที่สุด",
            api_url: "searchword/topsearch",
          },
          {
            name: "unknown_word",
            title: "อันดับการค้นหาคำศัพท์ที่ไม่มีในระบบ",
            text: "คำค้นหาที่ไม่มีในระบบ",
            api_url: "unknown_word",
          },
        ];
      } else {
        if (this.permission_history) {
          // history only
          this.search_mode_text = "คำที่ค้นหามากที่สุด";
          this.search_title = "อันดับการค้นหาคำศัพท์";
          this.api_url = "searchword/topsearch";
          this.mode = "topsearch";
          this.mode_list = [
            {
              name: "topsearch",
              title: "อันดับการค้นหาคำศัพท์",
              text: "คำที่ค้นหามากที่สุด",
              api_url: "searchword/topsearch",
            },
          ];
        } else if (this.permission_unknow_word) {
          // unknow word only
          this.search_mode_text = "คำค้นหาที่ไม่มีในระบบ";
          this.search_title = "อันดับการค้นหาคำศัพท์ที่ไม่มีในระบบ";
          this.api_url = "unknown_word";
          this.mode = "unknown_word";
          this.mode_list = [
            {
              name: "unknown_word",
              title: "อันดับการค้นหาคำศัพท์ที่ไม่มีในระบบ",
              text: "คำค้นหาที่ไม่มีในระบบ",
              api_url: "unknown_word",
            },
          ];
        } else {
          // else
        }
      }
      this.setDefaultMode();
      this.getHistory();
    },
    setDefaultMode() {
      switch (this.$route.params.mode) {
        case "history":
          this.search_mode_text = "คำที่ค้นหามากที่สุด";
          this.search_title = "อันดับการค้นหาคำศัพท์";
          this.api_url = "searchword/topsearch";
          this.mode = "topsearch";
          break;
        case "unknown_word":
          this.search_mode_text = "คำค้นหาที่ไม่มีในระบบ";
          this.search_title = "อันดับการค้นหาคำศัพท์ที่ไม่มีในระบบ";
          this.api_url = "unknown_word";
          this.mode = "unknown_word";
          break;
        default:
          this.$router.push({ name: "History", params: { mode: "history" } });
          break;
      }
    },
    getHistory() {
      clearTimeout(this.update_value_setTimeOut);
      this.update_value_setTimeOut = setTimeout(() => {
        this.updateHistoryValue();
      }, 200);
    },
    updateHistoryValue() {
      this.history = [];
      this.series = [];
      var number = [];
      var name = [];
      var rank = [];
      this.chartOptions = {};
      // date = "2020-07-01";
      var path = "";
      var qstr = "";
      if (this.type == "day") {
        qstr = "?date=" + this.date;
      } else if (this.type == "week") {
        var start = this.week[0];
        var end = this.week[1];
        qstr = "?start=" + start + "&end=" + end;
        path = "period/";
      } else if (this.type == "month") {
        var yy = this.month.split("-")[0];
        var mm = this.month.split("-")[1];
        qstr = "?month=" + mm + "&year=" + yy;
        path = "month/";
      } else if (this.type == "year") {
        var yy = this.year.split("-")[0];
        qstr = "?year=" + yy;
        path = "year/";
      }
      var item = this.filter_item;
      this.axios
        .get(
          process.env.VUE_APP_API +
            "api/v1/" +
            this.api_url +
            "/" +
            path +
            item +
            qstr,
          this.header_token
        )
        .then((res) => {
          let data = null;
          data = res.data;
          this.history = data;

          if (data.length > 0) {
            if (this.mode == "topsearch") {
              data.forEach((element, index) => {
                number.push(element.countPerDay);
                name.push(index + 1 + ". " + this.subString(element.alphabet));

                rank.push(index + 1);
              });
            } else if (this.mode == "unknown_word") {
              data.forEach((element, index) => {
                number.push(element.countPerDay);
                name.push(
                  index + 1 + ". " + this.subString(element.unknownWordName)
                );

                rank.push(index + 1);
              });
            }
            this.series.push({
              name: "การค้นหา",
              data: number,
            });
            this.chartOptions = {
              chart: {
                type: "bar",
                height: 350,
                toolbar: {
                  show: false,
                },
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "70%",
                  endingShape: "flat",
                },
              },
              dataLabels: {
                enabled: false,
              },

              stroke: {
                show: true,
                width: 2,
                colors: ["transparent"],
              },
              xaxis: {
                title: {
                  text: "อันดับ",
                },
                categories: name,
              },
              yaxis: {
                title: {
                  text: "จำนวนครั้ง",
                },
              },
              fill: {
                type: "gradient",
                gradient: {
                  shade: "dark",
                  type: "vertical",
                  shadeIntensity: 0.5,
                  gradientToColors: ["#8bd3f3", "#67b7e8", "#53a8e2"],
                  inverseColors: true,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100],
                },
              },
              tooltip: {
                y: {
                  formatter: function(val) {
                    return val + " ครั้ง";
                  },
                },
              },
            };
            // console.log(this.series);
          } else if (data.length == 0) {
            this.series.push({
              data: [],
            });
            this.chartOptions = {
              chart: {
                type: "bar",
                height: 350,
                toolbar: {
                  show: false,
                },
              },

              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "70%",
                  endingShape: "flat",
                },
              },
              dataLabels: {
                enabled: false,
              },
              stroke: {
                show: true,
                width: 2,
                colors: ["transparent"],
              },
              xaxis: {
                title: {
                  text: "อันดับ",
                },
                categories: [],
              },
              yaxis: {
                title: {
                  text: "จำนวนครั้ง",
                },
              },
              fill: {
                opacity: 1,
                // type: "gradient",
                // gradient: {
                //   shade: "dark",
                //   type: "vertical",
                //   shadeIntensity: 0.5,
                //   gradientToColors: ["#8bd3f3", "#67b7e8", "#53a8e2"],
                //   inverseColors: true,
                //   opacityFrom: 1,
                //   opacityTo: 1,
                //   stops: [0, 100],
                // },
              },
              tooltip: {
                y: {
                  formatter: function(val) {
                    return val + " ครั้ง";
                  },
                },
              },
            };
          }
        });
    },
    saveYear(date) {
      this.$refs.menu_year.save(date);
      this.$refs.picker.activePicker = "YEAR";
      this.menu_year = false;
    },

    exportExcel() {
      var item = this.filter_item;
      var path = "";
      var qstr = "";
      if (this.type == "day") {
        qstr = "?date=" + this.date;
      } else if (this.type == "week") {
        var start = this.week[0];
        var end = this.week[1];
        qstr = "?start=" + start + "&end=" + end;
        path = "period/";
      } else if (this.type == "month") {
        var yy = this.month.split("-")[0];
        var mm = this.month.split("-")[1];
        qstr = "?month=" + mm + "&year=" + yy;
        path = "month/";
      } else if (this.type == "year") {
        var yy = this.year.split("-")[0];
        qstr = "?year=" + yy;
        path = "year/";
      }
      var api_url = this.mode == "unknown_word" ? "unknown/" : "";
      this.axios({
        url:
          process.env.VUE_APP_API +
          "api/v1/export/" +
          api_url +
          path +
          item +
          qstr,

        method: "POST",
        responseType: "blob", // important
        headers: {
          token: this.$session.get("token_roy"),
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "รายงานประวัติการค้นหาคำศัพท์" +
            (this.mode == "unknown_word" ? "ที่ไม่มีในระบบ" : "") +
            ".xlsx"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    startOfWeek(date) {
      var diff =
        date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
      this.week[0] = new Date(date.setDate(diff)).toISOString().substr(0, 10);
    },
    endOfWeek(date) {
      var lastday = date.getDate() - (date.getDay() - 1) + 6;
      this.week[1] = new Date(date.setDate(lastday))
        .toISOString()
        .substr(0, 10);
    },
    subString(str) {
      if (!str) {
        return "";
      }
      var sub_str = str.substring(0, 10);
      return sub_str + (str.length > 10 ? "..." : "");
    },
    thaiShortFormatDate(datetime) {
      var date = datetime.split(" ")[0];
      if (!datetime) {
        return "";
      }
      var [year, month, day] = date.split("-");
      year = (parseInt(year) + 543).subString(2);
      switch (month) {
        case "01":
          month = "ม.ค.";
          break;
        case "02":
          month = "ก.พ.";
          break;
        case "03":
          month = "มี.ค.";
          break;
        case "04":
          month = "เม.ย.";
          break;
        case "05":
          month = "พ.ค.";
          break;
        case "06":
          month = "มิ.ย.";
          break;
        case "07":
          month = "ก.ค.";
          break;
        case "08":
          month = "ส.ค.";
          break;
        case "09":
          month = "ก.ย.";
          break;
        case "10":
          month = "ต.ค.";
          break;
        case "11":
          month = "พ.ย.";
          break;
        case "12":
          month = "ธ.ค.";
          break;

        default:
          break;
      }
      return day + " " + month + " " + year;
    },
    thaiLongFormatDate(datetime) {
      var date = datetime.split(" ")[0];
      if (!datetime) {
        return "";
      }
      var [year, month, day] = date.split("-");
      year = parseInt(year) + 543;
      switch (month) {
        case "01":
          month = "มกราคม";
          break;
        case "02":
          month = "กุมภาพันธ์";
          break;
        case "03":
          month = "มีนาคม";
          break;
        case "04":
          month = "เมษายน";
          break;
        case "05":
          month = "พฤษภาคม";
          break;
        case "06":
          month = "มิถุนายน";
          break;
        case "07":
          month = "กรกฎาคม";
          break;
        case "08":
          month = "สิงหาคม";
          break;
        case "09":
          month = "กันยายน";
          break;
        case "10":
          month = "ตุลาคม";
          break;
        case "11":
          month = "พฤศจิกายน";
          break;
        case "12":
          month = "ธันวาคม";
          break;

        default:
          break;
      }
      return day + " " + month + " " + year;
    },
    formatTime(datetime) {
      var time = datetime.split(" ")[1];
      var [hh, mm, ss] = time.split(":");
      return hh + ":" + mm;
    },
    formatDatePicker(date) {
      if (!date) {
        return null;
      }
      var [year, month, day] = date.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
    },
    formatWeekPicker(date) {
      if (!date) {
        return null;
      }
      if (date.length == 2) {
        var [start_year, start_month, start_day] = date[0].split("-");
        var [end_year, end_month, end_day] = date[1].split("-");
        return `${start_day}/${start_month}/${parseInt(start_year) +
          543} - ${end_day}/${end_month}/${parseInt(end_year) + 543}`;
      }
    },
    formatMonthPicker(month) {
      if (!month) {
        return null;
      }
      var [year, month] = month.split("-");
      return `${month}/${parseInt(year) + 543}`;
    },
    formatYearPicker(date) {
      if (!date) {
        return null;
      }
      var [year, month, day] = date.split("-");
      return `${parseInt(year) + 543}`;
    },
    formatType(type) {
      var format = null;
      switch (type) {
        case "day":
          format = "วัน";
          break;
        case "week":
          format = "สัปดาห์";
          break;
        case "month":
          format = "เดือน";
          break;
        case "year":
          format = "ปี";
          break;
        default:
          break;
      }
      return format;
    },
  },
};
</script>
<style>
.Line-3 {
  width: 1px;
  height: 100%;
  border: solid 1px #f4f4f4;
}
.skewed-bg {
  background: #e9f1fe;
  color: #fff;
  padding: 2em;
  position: relative;
  min-height: 300px;
  overflow: hidden;
  z-index: 0;
}
.skewed-bg::after {
  content: "";
  position: absolute;
  top: 200px;
  left: 0;
  right: 0;
  height: 100%;
  background: #fff;
  transform: skew(0deg, 0deg);
  z-index: 0;
}
.Radius-999px {
  width: 217px;
  height: 25px;
  border-radius: 999px;
  background-color: #d6e9bf;
}
</style>
